<template>
  <div class="card">
    <div class="card-panel center-align" :class="cardStyle">
      <p>
        <i class="material-icons left">{{icon || defaultIcon}}</i>
        <slot></slot>
      </p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'InformationCard',
    props: {
      icon: String,
      textColor: String,
      cardColor: String,
    },
    data () {
      return {
        defaultMmessage: 'Texto informativo',
        defaultIcon: 'error_outline',
      }
    }, computed: {
      textColorStyle () {
        return this.textColor || 'text-gray'
      },
      cardColorStyle () {
        return this.cardColor || 'grey lighten-2'
      },
      cardStyle () {
        return this.textColorStyle + ' ' + this.cardColorStyle
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/common/InformationCard.vue